import React, {FC} from 'react';

import HalfScreenWrapper from '@/components/HalfScreenWrapper';
import Logout from '@/components/Login/Logout';
import ProjectTable from '@/components/ProjectTable';

import {Project} from '@/domain/entities/Project';

type ProjectListProps = {
  projects: Array<Project>,
  onSelectedProject: (projectUuid: string) => void,
  errorMessage?: string,
  onLogout: () => void
}

const ProjectList: FC<ProjectListProps> = ({projects, onSelectedProject, onLogout, errorMessage}) => {

  return <HalfScreenWrapper>
    <Logout onLogout={onLogout}/>
    <ProjectTable projects={projects} errorMessage={errorMessage} onSelectedProject={onSelectedProject}/>
  </HalfScreenWrapper>;
};

export default ProjectList;